const milestones = [
  {
    number: '01',
    title: 'The Problem',
    body: 'We spent years building and scaling businesses across retail, hospitality, and e-commerce. Every processor felt the same: overpromised, underdelivered, and impossible to fully understand. We weren\'t just processing payments. We were losing visibility into our own revenue.',
    image: '/images/about/problem.jpg',
  },
  {
    number: '02',
    title: 'The Frustration',
    body: 'Fees were buried three layers deep, payouts showed up on someone else\'s timeline, and the dashboards looked good but told us nothing. Every question we asked led to more jargon, not answers.',
    image: '/images/about/frustration.jpg',
  },
  {
    number: '03',
    title: 'The Build',
    body: 'So we stopped trying to fix broken systems and built our own. Not just another processor, but a layer of infrastructure designed to give operators complete clarity and control over how their money moves, backed by a team that stays involved long after the contract is signed.',
    image: '/images/about/build.jpg',
  },
];

export default function AboutStory() {
  return (
    <section className="bg-[#F9F9F7] py-28 px-5 md:px-[75px] pt-[50px] pb-[50px]">
      <div className="max-w-[1400px] mx-auto">

        {/* Header */}
        <div className="mb-20 max-w-2xl">
          <p
            className="text-[#a8894a] text-[10px] uppercase tracking-[0.25em] font-medium mb-5"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            Our Story
          </p>
          <h2
            className="text-[#061e45] text-4xl md:text-5xl lg:text-[54px] font-light leading-[1.1]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            We Built the Missing Piece.
          </h2>
        </div>

        {/* Milestones — horizontal 3-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#d3b366]/15">
          {milestones.map((m) => (
            <div key={m.number} className="bg-[#F9F9F7] flex flex-col">

              {/* Photo */}
              <div className="w-full overflow-hidden" style={{ height: '240px' }}>
                <img
                  src={m.image}
                  alt={m.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div className="p-10 flex flex-col gap-6 flex-1">
                <p
                  className="text-[#a8894a] text-[10px] uppercase tracking-[0.2em] font-medium"
                  style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                >
                  {m.title}
                </p>
                <p
                  className="text-[#1A1A1A]/60 text-[14px]"
                  style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
                >
                  {m.body}
                </p>
              </div>

            </div>
          ))}
        </div>

      </div>

      {/* Gold divider */}
      <div className="max-w-[1400px] mx-auto flex items-center gap-6" style={{ marginTop: '100px' }}>
        <div className="flex-1 h-px bg-[#d3b366]/25" />
        <div className="w-2 h-2 rotate-45 bg-[#d3b366]/40" />
        <div className="flex-1 h-px bg-[#d3b366]/25" />
      </div>
    </section>
  );
}
